var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunny(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sunny") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sunny"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.48,
    cy: 100.47,
    r: 53.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "100.48 22.11 109.99 38.37 91.62 38.37 100.48 22.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "139.5 32.28 139.68 51.12 123.73 42 139.5 32.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "168.14 61.12 158.85 77.51 149.62 61.62 168.14 61.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.84 61.12 42.13 77.51 51.35 61.62 32.84 61.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.84 140.08 42.13 123.69 51.35 139.58 32.84 140.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "168.14 140.08 158.85 123.69 149.62 139.58 168.14 140.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "178.44 100.76 162.12 91.33 162.22 109.71 178.44 100.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.75 100.76 39.06 91.33 38.96 109.71 22.75 100.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.34 32.28 61.16 51.12 77.11 42 61.34 32.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.79 168.36 61.61 149.52 77.56 158.65 61.79 168.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "139.27 168.36 139.45 149.52 123.5 158.65 139.27 168.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "100.72 178.49 110.23 162.22 91.86 162.22 100.72 178.49"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.67dbf80d5e27cde99e43878ec0bc4dd3.svg";
export { ForwardRef as ReactComponent };